const cards = Array(10).fill(null);

export function ProductListSkeletonGrid() {
  return (
    <div className="product-list-skeleton-grid">
      {cards.map((_, index) => (
        <div key={index} className="product-list-skeleton-card">
          <div className="product-list-skeleton-card__image" />
          <div className="product-list-skeleton-card__code" />
          <div className="product-list-skeleton-card__brand" />
          <div className="product-list-skeleton-card__name" />
        </div>
      ))}
    </div>
  );
}

export default function ProductListLoading() {
  const categories = Array(5).fill(null);

  return (
    <div className="product-list-loading">
      <div className="product-list-skeleton-logo" />
      <div className="product-list-skeleton-pills">
        {categories.map((_, index) => (
          <div key={index} className="product-list-skeleton-pill" />
        ))}
      </div>
      <ProductListSkeletonGrid />
    </div>
  );
}
